<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'Merchants-list' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h3>Create New Merchant</h3>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent="validationNewMerchantForm">
            <b-row>
              <b-col md="4">
                <b-form-group label="Name" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetter($event)"
                      id="name-input"
                      v-model="newMerchantFormData.name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Channel" label-for="channel">
                  <validation-provider
                    #default="{ errors }"
                    name="Channel"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="channel-input"
                      v-model="newMerchantFormData.channel"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Approve URI" label-for="approvedURI">
                  <validation-provider
                    #default="{ errors }"
                    name="approvedURI"
                    rules="required"
                  >
                    <b-form-input
                      id="approvedURI-input"
                      v-model="newMerchantFormData.approvedURI"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Return URI" label-for="returnURI">
                  <validation-provider
                    #default="{ errors }"
                    name="returnURI"
                    rules="required"
                  >
                    <b-form-input
                      id="returnURI-input"
                      v-model="newMerchantFormData.returnURI"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Declined URI" label-for="declinedURI">
                  <validation-provider #default="{ errors }" name="declinedURI">
                    <b-form-input
                      id="declinedURI-input"
                      v-model="newMerchantFormData.declinedURI"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Cancel URI" label-for="cancelURI">
                  <validation-provider
                    #default="{ errors }"
                    name="cancelURI"
                    rules="required"
                  >
                    <b-form-input
                      id="cancelURI-input"
                      v-model="newMerchantFormData.cancelURI"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Pending URI" label-for="pendingURI">
                  <validation-provider #default="{ errors }" name="pendingURI">
                    <b-form-input
                      id="pendingURI-input"
                      v-model="newMerchantFormData.pendingURI"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Merchant Identifier"
                  label-for="merchantIdentifier"
                >
                  <validation-provider #default="{ errors }" name="pendingURI">
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="merchantIdentifier-input"
                      v-model="newMerchantFormData.merchantIdentifier"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Account Group" label-for="accountGroup">
                  <validation-provider
                    #default="{ errors }"
                    name="accountGroup"
                  >
                    <b-form-select
                      id="input-3"
                      v-model="newMerchantFormData.accountGroup"
                      :options="accountGroupEnum"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Authorization ShortCode"
                  label-for="authorizationShortCode"
                >
                  <validation-provider #default="{ errors }" name="pendingURI">
                    <b-form-input
                      id="authorizationShortCode-input"
                      v-model="newMerchantFormData.authorizationShortCode"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Company" label-for="companyId">
                  <validation-provider #default="{ errors }" name="companyId">
                    <b-form-select
                      id="input-3"
                      v-model="newMerchantFormData.companyId"
                      :options="companyIdOptions"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Bank shortcode" label-for="bankShortCode">
                  <validation-provider
                    #default="{ errors }"
                    name="bankShortCode"
                  >
                    <b-form-input
                      id="bankShortCode-input"
                      v-model="newMerchantFormData.bankShortCode"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="CBE Short code"
                  label-for="cbeBirrShortCode"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="cbeBirrShortCode"
                  >
                    <b-form-input
                      id="cbeBirrShortCode-input"
                      v-model="newMerchantFormData.cbeBirrShortCode"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="TeleBirr shortcode"
                  label-for="teleBirrShortCode"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="teleBirrShortCode"
                  >
                    <b-form-input
                      id="teleBirrShortCode-input"
                      v-model="newMerchantFormData.teleBirrShortCode"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Notification Listner UserName"
                  label-for="notificationListnerUserName"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="notificationListnerUserName"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="notificationListnerUserName-input"
                      v-model="newMerchantFormData.notificationListnerUserName"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Notification Listner Password"
                  label-for="notificationListnerPassword"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="notificationListnerPassword"
                  >
                    <b-form-input
                      id="notificationListnerPassword-input"
                      v-model="newMerchantFormData.notificationListnerPassword"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Default Expiry Hour"
                  label-for="defaultExpiryHour"
                >
                  <validation-provider #default="{ errors }" name="pendingURI">
                    <b-form-input
                      id="defaultExpiryHour-input"
                      v-model.number="newMerchantFormData.defaultExpiryHour"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Refund Capping Limit"
                  label-for="refundCappingLimit"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="refundCappingLimit"
                  >
                    <b-form-input
                      id="refundCappingLimit-input"
                      v-model.number="newMerchantFormData.refundCappingLimit"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund Confirmation NotifyURL"
                  label-for="refundConfirmationNotifyURL"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="refundConfirmationNotifyURL"
                  >
                    <b-form-input
                      id="refundConfirmationNotifyURL-input"
                      v-model="newMerchantFormData.refundConfirmationNotifyURL"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund Confirmation Email"
                  label-for="refundConfirmationEmail"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="refundConfirmationEmail"
                  >
                    <b-form-input
                      id="refundConfirmationEmail-input"
                      v-model="newMerchantFormData.refundConfirmationEmail"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="No Of Max Days Refund Is Allowed"
                  label-for="noOfMaxDaysRefundIsAllowed"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="noOfMaxDaysRefundIsAllowed"
                  >
                    <b-form-input
                      id="noOfMaxDaysRefundIsAllowed-input"
                      v-model.number="
                        newMerchantFormData.noOfMaxDaysRefundIsAllowed
                      "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Refund Access Type">
                  <b-form-select
                    id="input-3"
                    v-model="newMerchantFormData.refundAccessType"
                    :options="refundAccessTypeOptions"
                    @input="ChangeAssignedUser"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Refund To Separate Account"
                  label-for="refundToSeparateAccount"
                >
                  <b-form-checkbox
                    id="refundToSeparateAccount-input"
                    v-model="newMerchantFormData.refundToSeparateAccount"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Merchant Need Own Order Code"
                  label-for="merchantNeedOwnOrderCode"
                >
                  <b-form-checkbox
                    id="merchantNeedOwnOrderCode-input"
                    v-model="newMerchantFormData.merchantNeedOwnOrderCode"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Is Reconcilation Needed"
                  label-for="isReconcilationNeeded"
                >
                  <b-form-checkbox
                    id="isReconcilationNeeded-input"
                    v-model="newMerchantFormData.isReconcilationNeeded"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Confirmation Retry Required"
                  label-for="confirmRetryRequired"
                >
                  <b-form-checkbox
                    id="confirmRetryRequired-input"
                    v-model="newMerchantFormData.confirmRetryRequired"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="newMerchantFormData.confirmRetryRequired === true"
                md="2"
              >
                <b-form-group
                  label="Confirmation Retrial Attempt Allowed Count"
                  label-for="confirmRetrialAttemptAllowedCount"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="confirmRetrialAttemptAllowedCount"
                  >
                    <b-form-input
                      id="confirmRetrialAttemptAllowedCount-input"
                      v-model.number="
                        newMerchantFormData.confirmRetrialAttemptAllowedCount
                      "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- <b-col md="2">
                <b-form-group
                  label="Refund Action WorkFlow Required"
                  label-for="refundActionWorkFlowRequired"
                >
                  <b-form-checkbox
                    id="refundActionWorkFlowRequired-input"
                    v-model="newMerchantFormData.refundActionWorkFlowRequired"
                  />
                </b-form-group>
              </b-col> -->
            </b-row>

            <app-collapse
              v-if="newMerchantFormData.refundActionWorkFlowRequired"
              accordion
            >
              <app-collapse-item
                title="Refund Workflow configuration"
                :is-visible="true"
              >
                <div>
                  <b-col md="3">
                    <b-form-group
                      label="Refund Work Flow MinimumAmount"
                      label-for="refundActionWorkFlowRequiredMinimumAmount"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="refundActionWorkFlowRequiredMinimumAmount"
                      >
                        <b-form-input
                          id="refundActionWorkFlowRequiredMinimumAmount-input"
                          v-model.number="
                            newMerchantFormData.refundActionWorkFlowRequiredMinimumAmount
                          "
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <div>
                    <b-row
                      v-for="(item, index) in items"
                      :id="item.id"
                      :key="item.id"
                      ref="row"
                    >
                      <b-col md="2">
                        <b-form-group label="Level" label-for="item-name">
                          <b-form-input
                            id="item-name"
                            v-model="item.level"
                            type="number"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                          label="Assigned User Email"
                          label-for="email"
                        >
                          <v-select
                            v-model="item.userId"
                            :options="users"
                            label="text"
                            :clearable="true"
                            :value="value"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col lg="2" md="3" class="mb-50">
                        <b-button
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger"
                          class="mt-0 mt-md-2"
                          @click="removeItem(index)"
                        >
                          <feather-icon icon="XIcon" class="mr-25" />
                          <span>Delete</span>
                        </b-button>
                      </b-col>
                      <b-col cols="12">
                        <hr />
                      </b-col>
                    </b-row>
                  </div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>Next Level</span>
                  </b-button>
                </div>
              </app-collapse-item>
            </app-collapse>
            <br />
            <br />
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationNewMerchantForm"
            >
              Save
            </b-button>
          </form>
        </validation-observer>
      </b-card-body>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BCard,
  BButton,
  BFormCheckbox,
  BCardBody,
  BCardHeader,
  BFormSelect,
  BOverlay,
  BLink,
} from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import vSelect from "vue-select";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BCard,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BCardHeader,
    vSelect,
    BOverlay,
    BLink,
  },
  data() {
    return {
      required,
      isLoading: false,
      newMerchantFormData: {
        name: "",
        channel: "",
        cancelURI: "",
        pendingURI: "",
        approvedURI: "",
        returnURI: "",
        declinedURI: "",
        merchantIdentifier: "",
        accountGroup: null,
        authorizationShortCode: "",
        merchantLogo: "string",
        companyId: 1,
        defaultExpiryHour: 0,
        refundCappingLimit: 0,
        refundToSeparateAccount: false,
        refundActionWorkFlowRequired: false,
        refundActionWorkFlowRequiredMinimumAmount: 100,
        refundConfirmationNotifyURL: "",
        refundConfirmationEmail: "",
        noOfMaxDaysRefundIsAllowed: 0,
        sendEmailWhenUserAssignedForRefundWorkFlow: false,
        refundAccessType: 1,
        refundWorkFlow: [],
        bankShortCode: "",
        cbeBirrShortCode: "",
        teleBirrShortCode: "",
        notificationListnerUserName: "",
        notificationListnerPassword: "",
        merchantNeedOwnOrderCode: false,
        isReconcilationNeeded: false,
        confirmRetryRequired: false,
        confirmRetrialAttemptAllowedCount: 0,
      },
      accountGroupEnum: [
        { value: 1, text: "Revenue Ticket" },
        { value: 2, text: "E-Staff Ticket" },
        { value: 3, text: "Aviation University" },
        { value: 4, text: "Ethiopian Visa" },
        { value: 5, text: "Ethiopian Passport" },
        { value: 6, text: "Ethiopian OriginID" },
        { value: 7, text: "Ethiopian Cargo" },
      ],
      companyIdOptions: [],
      selectedMerchantName: "",
      items: [
        {
          level: 1,
          userId: 0,
        },
      ],
      nextTodoId: 1,
      users: [],
      selelctedLevels: [],
      refundAccessTypeOptions: [
        { value: 1, text: "Gatway" },
        { value: 2, text: "Merchant" },
      ],
      allUsers: [],
    };
  },
  mounted() {
    //this.initTrHeight();
  },
  created() {
    //window.addEventListener("resize", this.initTrHeight);
    this.fetchData();
  },
  destroyed() {
    //window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    isLetterandNumber(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z0-9_.,\s]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    validationNewMerchantForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.isLoading = true;
          this.newMerchantFormData.refundWorkFlow = [];

          this.items.forEach((item) => {
            this.newMerchantFormData.refundWorkFlow.push({
              level: item.level,
              userId: item.userId.value,
            });
          });

          console.log(this.newMerchantFormData);

          axios
            .post(
              "/Merchant/api/V1.0/Merchants/Create",
              this.newMerchantFormData
            )
            .then((res) => {
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.$router.push({ name: "Merchants-list" });
                  }
                });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Merchants-View");
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchantData")
        .then((res) => {
          this.users = [];
          this.allUsers = res.users;
          this.companyIdOptions = [];

          res.companies.forEach((item) => {
            this.companyIdOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          // res.users.filter(f => f.accessType === 1).forEach(item => {
          //   this.users.push({
          //     value: item.id,
          //     text: item.username,
          //   })
          // })
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    ChangeAssignedUser() {
      const usersFiltered = this.allUsers.filter(
        (f) => f.accessType === this.newMerchantFormData.refundAccessType
      );
      this.users = [];
      usersFiltered.forEach((item) => {
        this.users.push({
          value: item.id,
          text: item.username,
        });
      });
    },
    repeateAgain() {
      this.nextTodoId += 1;
      this.items.push({
        level: this.nextTodoId,
        userId: 0,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.nextTodoId -= 1;
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    // initTrHeight() {
    //   this.trSetHeight(null);
    //   this.$nextTick(() => {
    //     this.trSetHeight(this.$refs.form.scrollHeight);
    //   });
    // },
  },
};
</script>
